import { render, staticRenderFns } from "./ModalPdfPreview.vue?vue&type=template&id=5c7e55ce"
import script from "./ModalPdfPreview.vue?vue&type=script&lang=js"
export * from "./ModalPdfPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c7e55ce')) {
      api.createRecord('5c7e55ce', component.options)
    } else {
      api.reload('5c7e55ce', component.options)
    }
    module.hot.accept("./ModalPdfPreview.vue?vue&type=template&id=5c7e55ce", function () {
      api.rerender('5c7e55ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payslips/ModalPdfPreview.vue"
export default component.exports